import { render, staticRenderFns } from "./TariffAccidentItem.vue?vue&type=template&id=6ef5f678&scoped=true&"
import script from "./TariffAccidentItem.vue?vue&type=script&lang=ts&"
export * from "./TariffAccidentItem.vue?vue&type=script&lang=ts&"
import style0 from "./TariffAccidentItem.vue?vue&type=style&index=0&id=6ef5f678&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef5f678",
  null
  
)

export default component.exports